import { createAction } from 'redux-actions'

import * as constants from './constants'

export const fetchConversation = createAction(constants.FETCH_CONVERSATION)
export const fetchConversationPending = createAction(constants.FETCH_CONVERSATION_PENDING)
export const fetchConversationFailed = createAction(constants.FETCH_CONVERSATION_FAILED)
export const fetchConversationCancelled = createAction(constants.FETCH_CONVERSATION_CANCELLED)
export const receiveConversation = createAction(constants.RECEIVE_CONVERSATION)

export const patchConversation = createAction(constants.PATCH_CONVERSATION)
export const patchConversationPending = createAction(constants.PATCH_CONVERSATION_PENDING)
export const patchConversationFailed = createAction(constants.PATCH_CONVERSATION_FAILED)
export const patchConversationCancelled = createAction(constants.PATCH_CONVERSATION_CANCELLED)

export const fetchConversationList = createAction(constants.FETCH_CONVERSATION_LIST)
export const fetchConversationListPending = createAction(constants.FETCH_CONVERSATION_LIST_PENDING)
export const fetchConversationListCancelled = createAction(constants.FETCH_CONVERSATION_LIST_CANCELLED)
export const fetchConversationListFailed = createAction(constants.FETCH_CONVERSATION_LIST_FAILED)
export const fetchConversationListSuccess = createAction(constants.FETCH_CONVERSATION_LIST_SUCCESS)
export const fetchNextConversationList = createAction(constants.FETCH_NEXT_CONVERSATION_LIST)
export const fetchNextConversationListSuccess = createAction(constants.FETCH_NEXT_CONVERSATION_LIST_SUCCESS)

export const fetchConversationsCountForEndUserId = createAction(constants.FETCH_CONVERSATIONS_COUNT_FOR_END_USER_ID)
export const fetchConversationsCountForEndUserIdPending = createAction(constants.FETCH_CONVERSATIONS_COUNT_FOR_END_USER_ID_PENDING)
export const fetchConversationsCountForEndUserIdFailed = createAction(constants.FETCH_CONVERSATIONS_COUNT_FOR_END_USER_ID_FAILED)
export const fetchConversationsCountForEndUserIdSuccess = createAction(constants.FETCH_CONVERSATIONS_COUNT_FOR_END_USER_ID_SUCCESS)

export const fetchConversationsForEndUser = createAction(constants.FETCH_CONVERSATIONS_FOR_END_USER)
export const fetchConversationsForEndUserPending = createAction(constants.FETCH_CONVERSATIONS_FOR_END_USER_PENDING)
export const fetchConversationsForEndUserSuccess = createAction(constants.FETCH_CONVERSATIONS_FOR_END_USER_SUCCESS)
export const fetchConversationsForEndUserFailure = createAction(constants.FETCH_CONVERSATIONS_FOR_END_USER_FAILURE)

export const setPlaybookIdForConversation = createAction(constants.SET_PLAYBOOK_ID_FOR_CONVERSATION)

export const createConversation = createAction(constants.CREATE_CONVERSATION)
export const createConversationPending = createAction(constants.CREATE_CONVERSATION_PENDING)
export const createConversationFailed = createAction(constants.CREATE_CONVERSATION_FAILED)

export const setActiveConversation = createAction(constants.SET_ACTIVE_CONVERSATION)
export const unsetActiveConversation = createAction(constants.UNSET_ACTIVE_CONVERSATION)

export const setActiveConversationContactTabIndex = createAction(constants.SET_ACTIVE_CONVERSATION_CONTACT_TAB_INDEX)

export const conversationChanged = createAction(constants.CONVERSATION_CHANGED)

export const sendConversationTranscript = createAction(constants.SEND_CONVERSATION_TRANSCRIPT)
export const sendConversationTranscriptSuccess = createAction(constants.SEND_CONVERSATION_TRANSCRIPT_SUCCESS)
export const sendConversationTranscriptFailure = createAction(constants.SEND_CONVERSATION_TRANSCRIPT_FAILURE)

export const setQuery = createAction(constants.SET_QUERY)
export const setComposeModalStatus = createAction(constants.SET_COMPOSE_MODAL_STATUS)

export const fetchRoutingAuditLog = createAction(constants.FETCH_ROUTING_AUDIT_LOG)
export const fetchRoutingAuditLogPending = createAction(constants.FETCH_ROUTING_AUDIT_LOG_PENDING)
export const fetchRoutingAuditLogFailed = createAction(constants.FETCH_ROUTING_AUDIT_LOG_FAILED)
export const fetchRoutingAuditLogSuccess = createAction(constants.FETCH_ROUTING_AUDIT_LOG_SUCCESS)

export const selectConversation = createAction(constants.SELECT_CONVERSATION)
export const deselectConversation = createAction(constants.DESELECT_CONVERSATION)
export const selectConversations = createAction(constants.SELECT_CONVERSATIONS)
export const deselectConversations = createAction(constants.DESELECT_CONVERSATIONS)
export const deselectAllConversations = createAction(constants.DESELECT_ALL_CONVERSATIONS)

export const updateConversations = createAction(constants.UPDATE_CONVERSATIONS)

export const setConversationLimit = createAction(constants.SET_CONVERSATION_LIMIT)
export const setConversationLimitPending = createAction(constants.SET_CONVERSATION_LIMIT_PENDING)
export const setConversationLimitFailure = createAction(constants.SET_CONVERSATION_LIMIT_FAILURE)
export const setConversationLimitSuccess = createAction(constants.SET_CONVERSATION_LIMIT_SUCCESS)

export const fetchGlobalAutoCloseConfiguration = createAction(constants.FETCH_GLOBAL_AUTO_CLOSE_CONFIGURATION)
export const fetchGlobalAutoCloseConfigurationPending = createAction(constants.FETCH_GLOBAL_AUTO_CLOSE_CONFIGURATION_PENDING)
export const fetchGlobalAutoCloseConfigurationFailure = createAction(constants.FETCH_GLOBAL_AUTO_CLOSE_CONFIGURATION_FAILURE)
export const fetchGlobalAutoCloseConfigurationSuccess = createAction(constants.FETCH_GLOBAL_AUTO_CLOSE_CONFIGURATION_SUCCESS)

export const updateGlobalAutoCloseConfiguration = createAction(constants.UPDATE_GLOBAL_AUTO_CLOSE_CONFIGURATION)
export const updateGlobalAutoCloseConfigurationPending = createAction(constants.UPDATE_GLOBAL_AUTO_CLOSE_CONFIGURATION_PENDING)
export const updateGlobalAutoCloseConfigurationFailure = createAction(constants.UPDATE_GLOBAL_AUTO_CLOSE_CONFIGURATION_FAILURE)
export const updateGlobalAutoCloseConfigurationSuccess = createAction(constants.UPDATE_GLOBAL_AUTO_CLOSE_CONFIGURATION_SUCCESS)

export const fetchSuggestedArticles = createAction(constants.FETCH_SUGGESTED_ARTICLES)
export const fetchSuggestedArticlesPending = createAction(constants.FETCH_SUGGESTED_ARTICLES_PENDING)
export const fetchSuggestedArticlesSuccess = createAction(constants.FETCH_SUGGESTED_ARTICLES_SUCCESS)
export const fetchSuggestedArticlesFailed = createAction(constants.FETCH_SUGGESTED_ARTICLES_FAILED)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/conversation/actions.js